import { NgModule, LOCALE_ID,ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor } from '../app/layout/core/core.service';
import { CommunicationService } from '../app/layout/shared/communication.service';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import {AuthService} from './authentication/auth.service';
import { httpFactory } from '@angular/http/src/http_module';
import { HttpClientModule } from '@angular/common/http';
//import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';

export function httpintercept(xhrBackend: XHRBackend, requestOptions:
    RequestOptions, router: Router, communicationService: CommunicationService,authService:AuthService) {
    return new HttpInterceptor(xhrBackend, requestOptions, router, communicationService,authService);
}
@NgModule({
    imports: [
        HttpModule,HttpClientModule
    ],
    // providers: [//CommunicationService,AuthService,
    //     {
    //         provide: Http, useFactory: (httpintercept),
    //         deps: [XHRBackend, RequestOptions, Router, CommunicationService,AuthService] //,SharedService
    //     } 
    // ]
})
export class ApptokenModule {
    constructor (@Optional() @SkipSelf() parentModule: ApptokenModule) {
        if (parentModule) {
         //console.log('ApptokenModule is already loaded in the AppModule');
        }
      }

    static forRoot():ModuleWithProviders{
        return {
            ngModule:ApptokenModule,
            providers: [
                    {
                        provide: Http, useFactory: (httpintercept),
                        deps: [XHRBackend, RequestOptions, Router, CommunicationService,AuthService]
                    } 
                ]
        }; //return ends
    } //static forRoot ends
}